import type { MutableRefObject } from 'react'

import PropTypes from 'prop-types'
import { useState, useEffect, useRef, Children, isValidElement, cloneElement } from 'react'
import styled from 'styled-components'

import { elementStyle } from 'styles/element-style'

interface StreetViewProps extends google.maps.StreetViewPanoramaOptions {
  style?: Record<string, string>
  onClick?: (e: google.maps.MapMouseEvent) => void
  onStreetViewFullScreen?: () => void
  hidden: boolean
  children?: React.ReactNode
}

const StreetViewWrapper = styled.div`
  ${elementStyle}
`

export const StreetView: React.FC<StreetViewProps> = ({
  onStreetViewFullScreen,
  children,
  style,
  hidden,
  ...options
}) => {
  const ref = useRef<HTMLDivElement>() as MutableRefObject<HTMLInputElement>
  const [streetView, setStreetView] = useState<google.maps.StreetViewPanorama>()
  const [isFullScreen, setIsFullScreen] = useState(false)

  const isFullScreenStateRef = useRef(isFullScreen)
  const setIsFullScreenStateRef = (data: boolean) => {
    isFullScreenStateRef.current = data
    setIsFullScreen(data)
  }
  const handleEventFullScreen = () => {
    if (!isFullScreenStateRef.current) {
      onStreetViewFullScreen?.()
    }
    setIsFullScreenStateRef(!isFullScreenStateRef.current)
  }

  useEffect(() => {
    if (ref.current && !streetView && !hidden) {
      setStreetView(new google.maps.StreetViewPanorama(ref.current, {}))
      ref.current?.addEventListener('fullscreenchange', handleEventFullScreen)
    }
  }, [ref, streetView, hidden])

  useEffect(() => {
    if (streetView) {
      streetView.setOptions(options)
    }
  }, [streetView, options])

  return (
    <StreetViewWrapper ref={ref} id="street-view" style={style} hidden={hidden}>
      {Children.map(children, (child) => {
        if (isValidElement(child)) {
          return cloneElement(child)
        }
        return null
      })}
    </StreetViewWrapper>
  )
}
StreetView.propTypes = {
  style: PropTypes.objectOf(PropTypes.string.isRequired).isRequired,
  hidden: PropTypes.bool.isRequired,
}
